import { render, staticRenderFns } from "./PlaceholderPanel.vue?vue&type=template&id=061f2168&scoped=true&"
import script from "./PlaceholderPanel.vue?vue&type=script&lang=js&"
export * from "./PlaceholderPanel.vue?vue&type=script&lang=js&"
import style0 from "./PlaceholderPanel.vue?vue&type=style&index=0&id=061f2168&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061f2168",
  null
  
)

export default component.exports